import { render, staticRenderFns } from "./unsaved-changes-modal.vue?vue&type=template&id=3507b163&scoped=true"
import script from "./unsaved-changes-modal.vue?vue&type=script&lang=js"
export * from "./unsaved-changes-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3507b163",
  null
  
)

export default component.exports